module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cp-f6b10f55c03f66f740187a9e581f7e27.svg";